import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subscription, forkJoin } from "rxjs";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { RemplacerFichierComponent } from "src/app/formulaire/modal/remplacer-fichier/remplacer-fichier.component";
import { UploadInGarantieComponent } from "src/app/formulaire/modal/upload-in-garantie/upload-in-garantie.component";
import { GarantieDetail } from "src/app/parametrage/core/model/garanties/GarantieDetail";
import { GarantieDocument } from "src/app/parametrage/core/model/garanties/GarantieDocument";
import { GarantieService } from "src/app/parametrage/core/service/garantie.service";

@Component({
  selector: "app-add-document-garantie",
  templateUrl: "./add-document-garantie.component.html",
  styleUrls: ["./add-document-garantie.component.scss"],
})
export class AddDocumentGarantieComponent implements OnInit {
  garantie: GarantieDetail;
  requestId: number;
  documents: GarantieDocument[];
  isDocumentObligatoire: boolean = false;

  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  documentsGarantiesClients: SubItem[];
  errorMessage: string;

  constructor(
    private modalService: NgbModal,
    private _garantieService: GarantieService,
    private _gestionFichierService: GestionFichierService,
    public activeModal: NgbActiveModal
  ) {}
  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
  ngOnInit() {
    this.getEmptyDocumentsByRequestAndGarantie();
    this.getDocumentsByGarantieId();
    this.eventsSubscription = this.events.subscribe(() => {
      this.getEmptyDocumentsByRequestAndGarantie();
      this.getDocumentsByGarantieId();
    });
  }

  getEmptyDocumentsByRequestAndGarantie() {
    this._garantieService
      .getEmptyDocumentsByRequestAndGarantie(this.requestId, this.garantie.id)
      .subscribe((data) => {
        this.documents = data;
      });
  }

  getDocumentsByGarantieId() {
    this._gestionFichierService
      .getDocumentsByGarantieId(this.requestId, this.garantie.id)
      .subscribe(
        (data) => {
          this.documentsGarantiesClients = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInGarantieComponent, {
      backdrop: "static",
      centered: true,
      scrollable: true,
      size: "lg",
    });

    modalRef.componentInstance.garantieid = this.garantie.id;
    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        this.getEmptyDocumentsByRequestAndGarantie();
        this.getDocumentsByGarantieId();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFile(subitemId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  remplacerFichier(subitemId, name, displayname) {
    const modalRef = this.modalService.open(RemplacerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.codeDocument = name.split(".")[0];
    modalRef.componentInstance.displayname = displayname;

    modalRef.result.then(
      (data) => {
        this.getEmptyDocumentsByRequestAndGarantie();
        this.getDocumentsByGarantieId();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteFile(subItemId) {
    if (confirm("Êtes-vous sûr de vouloir supprimer cet élément ?")) {
      this._gestionFichierService.delete(subItemId).subscribe(
        (data) => {
          this.getEmptyDocumentsByRequestAndGarantie();
          this.getDocumentsByGarantieId();
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
}
